export function emailInviteHTML(toName, toEmail, fromName, yardName) {
  return `<!-- Begin HTML Content -->
        <h1> ${toName}, <br><br> Welcome to transloads.co! <br></h1>
        <hr style="background:#2d8cff; height: 8px; width: 60px; border-style: solid; border-color: #095484; border-width: 1px 0 0 0; border-radius: 8px;" />
        <br><br>
        ${fromName} at ${yardName} is inviting you to join transloads.co.
        To create your account, please click on the button below and register using this email address: <br>
        ${toEmail} <br>
        Once your account is activated, you will have full access to the Yard Management System.
        <br><br><br>
        <table bgcolor="#FF5F0F" style="border-radius:3px; border-spacing:0; margin:0 auto">
            <tbody>
                <tr style="background:#FF5F0F;">
                    <td class="mobile-cta" style="border: 0 solid #FF5F0F;  display: inline-block; padding: 20px 45px; text-align: center; font-family:'Lato', Helvetica, sans-serif; font-size:15px; line-height:24px; color:#FFFFFF; font-weight:900; text-decoration: none; text-transform: uppercase; letter-spacing: .2em">
                        <a href="https://app.transloads.co/?signUp"
                            target="_blank"
                            rel="noreferrer"
                            style="color:#FFFFFF; text-decoration:none;"
                        >
                            CREATE ACCOUNT
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
        <br><br>
        <hr style="border-bottom:#CCCCCC 6px dotted; border-width: 0 0 6px 0;">
        <br>
        Button not working? Try pasting this URL into your browser: <br>
        <strong>
            <a href="https://app.transloads.co/?signUp"
                target="_blank"
                rel="noreferrer"
                style="color: #2d8cff; text-decoration:none; word-break: break-all;"
            >
                https://app.transloads.co/?signUp
            </a>
        </strong>
        <!-- End HTML Content -->`;
}
